<template>
  <VBlock :direction="Direction.column" :padding="[0, 12, 25, 12]">
    <VBlock
      :padding="[0, 0, 20, 0]"
      :margin="[0, 0, 24]"
      class="rider-info"
      v-if="orderDetailStatus !== 'COMPLETED' && orderDetailStatus !== 'CANCELED'"
    >
      <VSpan
        text="라이더의 안전을 위해 폭우/폭설 또는 집회와 같이 배달이 어려운 경우 배달이 지연되거나 주문이 취소 될 수 있습니다."
        :size="11"
        :color="TextColor.gray2"
      />
    </VBlock>
    <VA :href="`tel:${customerServiceTelephoneNumber}`" :onClick="customerCenterLog">
      <VBlock :margin="[0, 0, 4, 0]">
        <VSpan text="고객센터 오전 9시 ~ 새벽 1시" :color="TextColor.gray2" :spacing="-0.37" />
        <VSpan
          class="tel"
          :text="customerServiceTelephoneNumber"
          :size="16"
          :weight="TextWeight.bold"
          :spacing="-0.37"
        />
      </VBlock>
    </VA>
    <VSpan :color="TextColor.gray2" text="Copyright Woowa Brothers in Song-pa, All Rights Reserved." :spacing="-0.37" />
  </VBlock>
</template>

<script>
import VA from '../../molecules/VA'
import VBlock, { Direction } from '../../molecules/VBlock/index'
import VSpan, { TextWeight, TextColor } from '../../atoms/VSpan/index'

export default {
  name: 'OrderDetailCustomerCenter',
  components: { VSpan, VBlock, VA },
  props: {
    orderDetailStatus: {
      type: String,
      required: true
    },
    customerServiceTelephoneNumber: {
      type: String,
      required: true
    },
    customerCenterLog: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      Direction,
      TextColor,
      TextWeight
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.rider-info {
  border-bottom: 1px solid $light-gray-5;
}

.tel {
  margin-left: 4px;
}
</style>
